/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { useTheme } from "@mui/material/styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const IconDisplay = (props) => {

    const theme = useTheme();
    const icon = props?.icon;
    const activeColor = theme.palette.primary.main;
    const inactiveColor = theme.palette.grey[100];
    
    return (
        <div className='icon-display'>
            {icon &&
                <>
                    <div>
                        <FontAwesomeIcon
                            icon={`fa-solid ${icon || "fa-minus-circle"}`}
                            style={{
                                fontSize: "4em",
                                color: icon ? activeColor : inactiveColor,
                            }}
                            size={"lg"}
                        />
                    </div>
                    <div className="icon-display-id">
                        {icon}
                    </div>
                </>
            }
        </div>
    );
};

export { IconDisplay };
